import { render, staticRenderFns } from "./PracticeMembersPage.vue?vue&type=template&id=5cd60e11&scoped=true"
import script from "./PracticeMembersPage.vue?vue&type=script&lang=js"
export * from "./PracticeMembersPage.vue?vue&type=script&lang=js"
import style0 from "./PracticeMembersPage.vue?vue&type=style&index=0&id=5cd60e11&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd60e11",
  null
  
)

export default component.exports